import { apiSections }                                                                         from 'dmpconnectjsapp-base/constants';
import { immunizationApproachSitesLabels, immunizationRoutesLabels, immunizationTypesLabels } from 'dmpconnectjsapp-base/constants/immunization';
import { getInteropCodesFromState }                                                           from 'dmpconnectjsapp-base/helpers/accessors';
import { getAccessRightsProps }                                                               from 'dmpconnectjsapp-base/rules/accessRights';
import { extractHpStructureFromState }                                                        from 'dmpconnectjsapp-base/utils/hp';
import moment                                                                                  from 'moment';
import PropTypes                                                                               from 'prop-types';
import * as React                                                                              from 'react';
import { Form }                                                                                from 'react-bootstrap';
import { connect }                                                                             from 'react-redux';
import { getObjectKeyFromPath }                                                               from '../../dmpconnect/utils/dataUtils';
import CustomCheckbox                                                                          from '../Common/Form/Input/CustomCheckbox';
import UserSettingInput                                                                        from '../DMPConfiguration/Input/UserSettingInput';
import FhirAsyncTypeAhead                                                                      from '../fhir/FhirAsyncTypeAhead';
import AtcCodeImmunizationInput, { getAtcCodeDesc }                                           from '../interop/AtcCodeImmunizationInput';
import CisCodeAsyncTypeAhead                                                                   from '../interop/CisCodeAsyncTypeAhead';

const ImmunizationForm = ({
  errors,
  setFieldValue,
  immunizationNote,
  practiceSettings,
  hp,
  atcImmunizationsCodes,
  serviceStartDate,
  psId,
}) => {
  const [cisCode, setCisCode]             = React.useState();
  const [atcCode, setAtcCode]             = React.useState();
  const [name, setName]                   = React.useState();
  const [lotNumber, setLotNumber]         = React.useState();
  const [type, setType]                   = React.useState();
  const [route, setRoute]                 = React.useState();
  const [approachSite, setApproachSite]   = React.useState();
  const [comment, setComment]             = React.useState();
  const [performer, setPerformer]         = React.useState();
  const [rank, setRank]                   = React.useState();
  const [doseQuantity, setDoseQuantity]   = React.useState();
  const [initialized, setInitialized]     = React.useState(false);
  const [selfPerformer, setSelfPerformer] = React.useState();
  
  const setCurrentHpAsPerformer = React.useCallback((isSelfPerformer) => {
    setPerformer(isSelfPerformer ? hp : undefined);
    setSelfPerformer(isSelfPerformer);
  }, []);
  
  const setPracticeSetting = React.useCallback((practiceSetting) => {
    setPerformer(previous => ({
      ...(previous || {}),
      Institution: {
        ...(previous && previous.Institution ? previous.Institution : {}),
        s_classCode: practiceSetting,
      },
    }));
  }, [performer]);
  
  React.useEffect(() => {
    const
      {
        i_approachSite,
        i_doseQuantity,
        i_immunizationRoute,
        i_rank,
        i_type = 1,
        Comment   : {
          s_text,
        }      = {},
        Consumable: {
          s_atcCode,
          s_cisCode,
          s_lotNumber,
          s_name,
        }      = {},
        Performer,
      } = immunizationNote;
    
    setLotNumber(s_lotNumber);
    setCisCode(s_cisCode);
    setAtcCode(s_atcCode);
    setName(s_name);
    setType(i_type);
    setRoute(i_immunizationRoute);
    setApproachSite(i_approachSite);
    setComment(s_text);
    setRank(i_rank);
    setDoseQuantity(i_doseQuantity);
    setInitialized(true);
    setPerformer(Performer || hp);
    setSelfPerformer(!Performer || Performer.s_hpInternalId === psId);
  }, []);
  
  React.useEffect(() => {
    if (initialized) {
      const newImmunizationNote = {
        ...immunizationNote,
        i_approachSite     : Number(approachSite || 0),
        i_immunizationRoute: Number(route || 0),
        i_type             : Number(type || 1),
        i_rank             : Number(rank || 0),
        i_doseQuantity     : Number(doseQuantity || 0),
        s_date             : moment(serviceStartDate, 'DD/MM/YYYY').format('YYYYMMDD'),
        Comment            : comment ? {
          s_text: comment,
          Author: hp,
        } : undefined,
        Consumable         : {
          s_atcCode           : atcCode,
          s_atcCodeDescription: getAtcCodeDesc(atcImmunizationsCodes, atcCode),
          s_cisCode           : cisCode,
          s_cisCodeDescription: name,
          s_lotNumber         : lotNumber,
          s_name              : name,
        },
        Performer          : performer,
        Author             : hp,
      };
      
      // const hashStructuredBody    = JSum.digest(immunizationNote, 'SHA256', 'hex');
      // const hashNewStructuredBody = JSum.digest(newImmunizationNote, 'SHA256', 'hex');
      
      // if (hashNewStructuredBody !== hashStructuredBody) {
      setFieldValue('immunizationNote', newImmunizationNote);
      // }
    }
  }, [
    cisCode,
    atcCode,
    name,
    type,
    route,
    approachSite,
    comment,
    performer,
    rank,
    doseQuantity,
    lotNumber,
    serviceStartDate,
    initialized,
  ]);
  
  return (
    <>
      <Form.Group>
        <Form.Label>Code CIS</Form.Label>
        <CisCodeAsyncTypeAhead
          name="cisCode"
          id="cisCode"
          onChange={(event) => {
            const
              {
                target: {
                  value: { cisCode, atcCode, name } = {},
                } = {},
              } = event;
            
            setName(name);
            setCisCode(cisCode);
            if (!!atcCode) {
              setAtcCode(atcCode);
            }
          }}
          selectedCodes={!!cisCode && !!atcCode && !!name ? [{ cisCode, name, atcCode }] : []}
          isInvalid={!!getObjectKeyFromPath('immunizationNote.Consumable.s_cisCode', errors)}
          disabled={immunizationNote.vacNoteToValidate}
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Code ATC</Form.Label>
        <AtcCodeImmunizationInput
          name="productAtcCode"
          id="productAtcCode"
          onChange={(event) => setAtcCode(event.target.value)}
          value={atcCode}
          isInvalid={!!getObjectKeyFromPath('immunizationNote.Consumable.s_atcCode', errors)}
          disabled={immunizationNote.vacNoteToValidate}
        />
      </Form.Group>
      
      <Form.Group>
        <Form.Label>Numéro de lot</Form.Label>
        <Form.Control
          name="lotNumber"
          id="lotNumber"
          // onChange={handleChange}
          onChange={(event) => setLotNumber(event.target.value)}
          value={lotNumber}
          isInvalid={!!getObjectKeyFromPath('immunizationNote.Consumable.s_lotNumber', errors)}
        />
      </Form.Group>
      
      <Form.Group>
        <Form.Label>Quantité</Form.Label>
        <Form.Control
          name="doseQuantity"
          id="doseQuantity"
          // onChange={handleChange}
          onChange={(event) => setDoseQuantity(event.target.value)}
          value={doseQuantity}
          isInvalid={!!getObjectKeyFromPath('immunizationNote.i_doseQuantity', errors)}
        />
      </Form.Group>
      
      <Form.Group>
        <Form.Label>Type de vaccination</Form.Label>
        <Form.Control
          as="select"
          name="type"
          onChange={(event) => setType(event.target.value)}
          value={type}
          isInvalid={!!getObjectKeyFromPath('immunizationNote.i_type', errors)}
        >
          <option value={0} key={0} disabled>Sélectionner une valeur</option>
          {Object.entries(immunizationTypesLabels).map(([code, label]) => <option key={code} value={code}>{label}</option>)}
        </Form.Control>
      </Form.Group>
      
      <Form.Group>
        <Form.Label>Rang de vaccination</Form.Label>
        <Form.Control
          name="rank"
          id="rank"
          type="number"
          min={0}
          // onChange={handleChange}
          onChange={(event) => setRank(event.target.value)}
          value={rank}
          isInvalid={!!getObjectKeyFromPath('immunizationNote.i_rank', errors)}
        />
      </Form.Group>
      
      <Form.Group>
        <Form.Label>Voie d'administration</Form.Label>
        <Form.Control
          as="select"
          name="route"
          onChange={(event) => setRoute(event.target.value)}
          value={route}
          isInvalid={!!getObjectKeyFromPath('immunizationNote.i_immunizationRoute', errors)}
        >
          <option value={0} key={0} disabled>Sélectionner une valeur</option>
          {Object.entries(immunizationRoutesLabels).map(([code, label]) => <option key={code} value={code}>{label}</option>)}
        </Form.Control>
      </Form.Group>
      
      <Form.Group>
        <Form.Label>Zone d'injection</Form.Label>
        <Form.Control
          as="select"
          name="approachSite"
          onChange={(event) => setApproachSite(event.target.value)}
          value={approachSite}
          isInvalid={!!getObjectKeyFromPath('immunizationNote.i_approachSite', errors)}
        >
          <option value={0} key={0} disabled>Sélectionner une valeur</option>
          {Object.entries(immunizationApproachSitesLabels).map(([code, label]) => <option key={code} value={code}>{label}</option>)}
        </Form.Control>
      </Form.Group>
      
      <Form.Group>
        <Form.Label>Commentaire</Form.Label>
        <Form.Control
          as="textarea"
          rows={5}
          name="comment"
          onChange={(event) => setComment(event.target.value)}
          value={comment}
          isInvalid={!!getObjectKeyFromPath('immunizationNote.Comment.s_text', errors)}
        />
      </Form.Group>
      
      <Form.Group>
        <CustomCheckbox
          id="self-performer-checkbox"
          checked={selfPerformer}
          label="Je suis le vaccinateur"
          inline
          onChange={() => setCurrentHpAsPerformer(!selfPerformer)}
        />
      </Form.Group>
      
      <Form.Group>
        <Form.Label>Vaccinateur</Form.Label>
        <FhirAsyncTypeAhead
          id="performer"
          name="performer"
          subSection="immunization"
          onChange={(event) => setPerformer(event.target.value)}
          value={!!performer ? [performer] : []}
          multiple={false}
          disabled={selfPerformer}
        />
      </Form.Group>
      
      {performer && !selfPerformer && (
        <Form.Group>
          <Form.Label>
            Veuillez choisir le cadre d'exercice du vaccinateur
          </Form.Label>
          <UserSettingInput
            choices={practiceSettings.filter(setting => setting.oid === '1.2.250.1.213.1.1.4.9')}
            onChange={event => setPracticeSetting(event.target.value)}
            name="practiceSetting"
            value={performer && performer.Institution ? performer.Institution.s_classCode : ''}
            // isInvalid={practiceSetting === null}
          />
        </Form.Group>
      )}
    </>
  );
};

ImmunizationForm.propTypes    = {
  setFieldValue        : PropTypes.func.isRequired,
  immunizationNote     : PropTypes.object,
  errors               : PropTypes.object,
  practiceSettings     : PropTypes.array.isRequired,
  hp                   : PropTypes.object.isRequired,
  atcImmunizationsCodes: PropTypes.array.isRequired,
  serviceStartDate     : PropTypes.string.isRequired,
  psId                 : PropTypes.string.isRequired,
};
ImmunizationForm.defaultProps = {
  immunizationNote: {},
  errors          : {},
  hp              : {},
};

function mapStateToProps (state, props) {
  const { dmpconnectInteropCodes: { [apiSections.ATC_IMMUNIZATION_CODES]: { Codes = [] } = {} } } = state;
  const { accessRights: { psId } }                                                                = getAccessRightsProps(state);
  return {
    practiceSettings     : getInteropCodesFromState(state, 'practiceSettings'),
    hp                   : extractHpStructureFromState(state),
    atcImmunizationsCodes: Codes,
    psId,
  };
}

export default connect(mapStateToProps)(ImmunizationForm);
